import { useState } from "react";

import { Dialog, DialogContent } from "@mui/material";

import ButtonMenu from "../atoms/buttons/ButtonMenu";

import ManualTransactionsInput from "../inputs/emissions/ManualTransactionsInput";
import MultipleTransactionsUploader from "../inputs/csv-uploaders/MultipleTransactionsUploader";
import EmissionsVolumeForm from "../inputs/emissions/EmissionsVolumeForm";
import SmartUploadFlow from "./smart-upload/SmartUploadFlow";
import usePermissions from "../../helpers/hooks/usePermissions";

const AddEmissionsMenu = ({ fullWidth }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { canEdit } = usePermissions();

  const closeDialog = () => setDialogOpen(false);

  const inputDialogs = {
    transactionsCsv: (
      <MultipleTransactionsUploader
        setOpen={setDialogOpen}
        open={!!dialogOpen}
      />
    ),
    manualTransactions: (
      <ManualTransactionsInput setDialogOpen={setDialogOpen} />
    ),
    volumeTransactions: <EmissionsVolumeForm setDialogOpen={setDialogOpen} />
  };

  if (!canEdit) {
    return null;
  }

  return (
    <>
      {dialogOpen && inputDialogs[dialogOpen]}
      <Dialog
        open={dialogOpen === "smartUpload"}
        onClose={closeDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogContent>
          <SmartUploadFlow onClose={closeDialog} />
        </DialogContent>
      </Dialog>
      <ButtonMenu
        color="secondary"
        variant="contained"
        fullWidth={fullWidth}
        menuOptions={[
          {
            label: "Upload Emissions",
            onClick: () => setDialogOpen("transactionsCsv")
          },
          {
            label: "Upload Documents",
            onClick: () => setDialogOpen("smartUpload")
          },
          {
            label: "Add a Single Emission",
            onClick: () => setDialogOpen("manualTransactions")
          },
          {
            label: "Add Emission Volume",
            onClick: () => setDialogOpen("volumeTransactions")
          }
        ]}
      />
    </>
  );
};
export default AddEmissionsMenu;
